// Customer document types for RAG pipeline

export type DocumentCategory =
  | 'procedure'
  | 'custom_module'
  | 'troubleshooting'
  | 'configuration'
  | 'training'
  | 'release_notes'
  | 'api_docs'
  | 'other'

export type ProcessingStatus =
  | 'pending'
  | 'extracting'
  | 'chunking'
  | 'embedding'
  | 'completed'
  | 'failed'

export interface CustomerDocument {
  id: string
  organization_id: string
  uploaded_by: string
  title: string
  description: string | null
  category: DocumentCategory
  file_name: string
  file_type: string
  file_size_bytes: number
  storage_path: string
  d365_version: string | null
  d365_module: string | null
  tags: string[]
  processing_status: ProcessingStatus
  processing_error: string | null
  chunk_count: number
  is_active: boolean
  created_at: string
  updated_at: string
}

export interface DocumentChunkResult {
  chunkId: string
  documentId: string
  documentTitle: string
  chunkIndex: number
  content: string
  similarity: number
  confidence: 'high' | 'medium' | 'low'
  category: DocumentCategory
  fileName: string
  d365Version: string | null
  d365Module: string | null
}

export interface DocumentSearchResponse {
  query: string
  results: DocumentChunkResult[]
  metadata: {
    totalMatches: number
    executionTimeMs: number
    provider: string
  }
}

export interface DocumentUploadFormData {
  file: File
  title: string
  category: DocumentCategory
  customer_id: string
  description?: string
  d365_version?: string
  d365_module?: string
  tags?: string
  save_to_kb?: boolean
}

export const DOCUMENT_CATEGORIES: { value: DocumentCategory; label: string }[] = [
  { value: 'procedure', label: 'Procedure' },
  { value: 'custom_module', label: 'Custom Module' },
  { value: 'troubleshooting', label: 'Troubleshooting' },
  { value: 'configuration', label: 'Configuration' },
  { value: 'training', label: 'Training' },
  { value: 'release_notes', label: 'Release Notes' },
  { value: 'api_docs', label: 'API Docs' },
  { value: 'other', label: 'Other' },
]
